// tslint:disable: completed-docs
import { IOfferFromJSON } from '../../../types';

/**
 * Interface for offerId => Multipicker
 */
export interface IOfferKeyElements {
    has_mobilfunk: boolean;
    has_internet: boolean;
    has_tv: boolean;
    has_none: boolean;
    wants_mobilfunk: boolean;
    wants_internet: boolean;
    wants_tv: boolean;
    wants_redplus: boolean;
}

/**
 * Generates Offer-Id by given attributes
 * @param elements
 */
export const generateOfferId = (elements: IOfferKeyElements): string => {

    return (elements.has_mobilfunk ? '1' : '0') +
        (elements.has_internet ? '1' : '0') +
        (elements.has_tv ? '1' : '0') +
        (elements.has_none ? '1' : '0') +
        (elements.wants_mobilfunk ? '1' : '0') +
        (elements.wants_internet ? '1' : '0') +
        (elements.wants_tv ? '1' : '0') +
        (elements.wants_redplus ? '1' : '0');
};

/**
 * Generates single Elements for Multipicker out of string
 * @param offerId
 */
export const retrieveFromOfferId = (offerId: string): IOfferKeyElements => {
    return {
        has_mobilfunk: ('1' === offerId.charAt(0)),
        has_internet: ('1' === offerId.charAt(1)),
        has_tv: ('1' === offerId.charAt(2)),
        has_none: ('1' === offerId.charAt(3)),
        wants_mobilfunk: ('1' === offerId.charAt(4)),
        wants_internet: ('1' === offerId.charAt(5)),
        wants_tv: ('1' === offerId.charAt(6)),
        wants_redplus: ('1' === offerId.charAt(7)),
    };
};

/**
 * Checks, if angebot_2 is filled in current offer and if so, gets this one, too
 * @param primaryOffers
 * @param allOffers
 */
const getAlternativOffers = (primaryOffers: IOfferFromJSON[], allOffers: IOfferFromJSON[]): IOfferFromJSON[] => {

    // check, if angebot_2 is filled (i.e. alternative offer exists)
    const alternatives = primaryOffers.filter((offer) => {
        return '' !== offer.Angebot_2;
    }).map((offer) => {
        return offer.Angebot_2;
    });

    let alternativeOffers = [];
    if (0 < alternatives.length) {
        alternativeOffers = getOffers(alternatives, allOffers);
    }

    return alternativeOffers;
};

/**
 * get Offers by Id
 * @param offerIds
 * @param offers
 */
export const getOffers = (offerIds: string[], offers): IOfferFromJSON[] => {

    let primaryOffers: any[];
    let alternativeOffers = [];
    const offerIdsLength = offerIds.length;

    if (0 === offerIdsLength) {
        return [];
    }

    // Retrieve primary offers for given offerIds
    primaryOffers = offers.filter((offer) => {
        let found: boolean = false;
        for (let i = 0; i < offerIdsLength; i++) {
            found = 0 <= offer.ID.indexOf(offerIds[i]);
            if (found) {
                break;
            }
        }

        return found;
    });

    // Check for alternative Offers defined in the primary offers
    if (0 < primaryOffers.length) {
        alternativeOffers = getAlternativOffers(primaryOffers, offers);

    }

    return primaryOffers.concat(alternativeOffers);
};

/**
 * When data is transformed from XLS to JSON it can happen, that in an XLS cell
 * if it should be empty, " " was entered. To avoid any problems, we trim every entry
 * @param data
 */

export const trimOfferElements = (data: any): any => {

    return data.map((entry) => {
        // trim all entries in one offer
        Object.keys(entry).forEach(k => entry[k] = entry[k].trim());

        return entry;
    });
};
